"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPetAddon = exports.isChildAddon = exports.isAdultAddon = exports.isFamilyAddon = exports.isTierThreeAddon = exports.isTierTwoAddon = exports.isTierOneAddon = exports.isBusinessAddon = exports.isUSMediumAddon = exports.isCurrentAddon = exports.areAllValidAddonsForPlan = exports.hasMinimumRequiredAddonsForPlan = exports.getOptionalAddonsForPlanId = exports.getRequiredAddonsForPlanId = exports.petAddonIds = exports.childAddonIds = exports.adultAddonIds = exports.tier3AddonIds = exports.tier2AddonIds = exports.tier1AddonIds = exports.businessLocationAddonMapper = exports.businessAddons = exports.businessAddonsEU = exports.businessAddonsGB = exports.businessAddonsCA = exports.businessAddonsAU = exports.businessAddonsUSDMedium = exports.businessAddonsUS = exports.familyAddons = exports.familyLocationAddonMapper = exports.familyAddonsEU = exports.familyAddonsGB = exports.familyAddonsCA = exports.familyAddonsAU = exports.familyAddonsUSDMedium = exports.familyAddonsUS = void 0;
const tree_projects_1 = require("../tree-projects");
const user_1 = require("../user");
const impact_stats_1 = require("./impact-stats");
const plans_1 = require("./plans");
const country_transform_1 = require("./country-transform");
exports.familyAddonsUS = {
    adults: {
        id: 'adult-v3-usd',
        price: 10.5,
        stats: impact_stats_1.b2cImpactStats.high.personal,
    },
    children: {
        id: 'child-v3-usd',
        price: 5.3,
        stats: impact_stats_1.b2cImpactStats.high.children,
    },
    pets: {
        id: 'pet-v3-usd',
        price: 0.7,
        stats: impact_stats_1.b2cImpactStats.high.pets,
    },
};
exports.familyAddonsUSDMedium = {
    adults: {
        id: 'adult-v3-usd-medium',
        price: 6.4,
        stats: impact_stats_1.b2cImpactStats.medium.personal,
    },
    children: {
        id: 'child-v3-usd-medium',
        price: 3.2,
        stats: impact_stats_1.b2cImpactStats.medium.children,
    },
    pets: {
        id: 'pet-v3-usd-medium',
        price: 0.7,
        stats: impact_stats_1.b2cImpactStats.medium.pets,
    },
};
exports.familyAddonsAU = {
    adults: {
        id: 'adult-v3-aud',
        price: 15.4,
        stats: impact_stats_1.b2cImpactStats.high.personal,
    },
    children: {
        id: 'child-v3-aud',
        price: 7.7,
        stats: impact_stats_1.b2cImpactStats.high.children,
    },
    pets: {
        id: 'pet-v3-aud',
        price: 1,
        stats: impact_stats_1.b2cImpactStats.high.pets,
    },
};
exports.familyAddonsCA = {
    adults: {
        id: 'adult-v3-cad',
        price: 14.1,
        stats: impact_stats_1.b2cImpactStats.high.personal,
    },
    children: {
        id: 'child-v3-cad',
        price: 7.05,
        stats: impact_stats_1.b2cImpactStats.high.children,
    },
    pets: {
        id: 'pet-v3-cad',
        price: 1,
        stats: impact_stats_1.b2cImpactStats.high.pets,
    },
};
exports.familyAddonsGB = {
    adults: {
        id: 'adult-v3-gbp',
        price: 4.7,
        stats: impact_stats_1.b2cImpactStats.medium.personal,
    },
    children: {
        id: 'child-v3-gbp',
        price: 2.4,
        stats: impact_stats_1.b2cImpactStats.medium.children,
    },
    pets: {
        id: 'pet-v3-gbp',
        price: 0.5,
        stats: impact_stats_1.b2cImpactStats.medium.pets,
    },
};
exports.familyAddonsEU = {
    adults: {
        id: 'adult-v3-eur',
        price: 5.6,
        stats: impact_stats_1.b2cImpactStats.medium.personal,
    },
    children: {
        id: 'child-v3-eur',
        price: 2.8,
        stats: impact_stats_1.b2cImpactStats.medium.children,
    },
    pets: {
        id: 'pet-v3-eur',
        price: 0.6,
        stats: impact_stats_1.b2cImpactStats.medium.pets,
    },
};
exports.familyLocationAddonMapper = {
    GB: exports.familyAddonsGB,
    US: exports.familyAddonsUS,
    AU: exports.familyAddonsAU,
    CA: exports.familyAddonsCA,
    EU: exports.familyAddonsEU,
    AD: exports.familyAddonsUSDMedium,
    AF: exports.familyAddonsUSDMedium,
    AG: exports.familyAddonsUSDMedium,
    AL: exports.familyAddonsUSDMedium,
    AM: exports.familyAddonsUSDMedium,
    AO: exports.familyAddonsUSDMedium,
    AQ: exports.familyAddonsUSDMedium,
    AR: exports.familyAddonsUSDMedium,
    AW: exports.familyAddonsUSDMedium,
    AZ: exports.familyAddonsUSDMedium,
    BA: exports.familyAddonsUSDMedium,
    BB: exports.familyAddonsUSDMedium,
    BD: exports.familyAddonsUSDMedium,
    BF: exports.familyAddonsUSDMedium,
    BI: exports.familyAddonsUSDMedium,
    BJ: exports.familyAddonsUSDMedium,
    BM: exports.familyAddonsUSDMedium,
    BO: exports.familyAddonsUSDMedium,
    BQ: exports.familyAddonsUSDMedium,
    BR: exports.familyAddonsUSDMedium,
    BS: exports.familyAddonsUSDMedium,
    BT: exports.familyAddonsUSDMedium,
    BY: exports.familyAddonsUSDMedium,
    CD: exports.familyAddonsUSDMedium,
    CI: exports.familyAddonsUSDMedium,
    CL: exports.familyAddonsUSDMedium,
    CM: exports.familyAddonsUSDMedium,
    CN: exports.familyAddonsUSDMedium,
    CO: exports.familyAddonsUSDMedium,
    CR: exports.familyAddonsUSDMedium,
    CU: exports.familyAddonsUSDMedium,
    CV: exports.familyAddonsUSDMedium,
    CW: exports.familyAddonsUSDMedium,
    DO: exports.familyAddonsUSDMedium,
    DZ: exports.familyAddonsUSDMedium,
    EC: exports.familyAddonsUSDMedium,
    EG: exports.familyAddonsUSDMedium,
    EH: exports.familyAddonsUSDMedium,
    ET: exports.familyAddonsUSDMedium,
    FJ: exports.familyAddonsUSDMedium,
    FK: exports.familyAddonsUSDMedium,
    FM: exports.familyAddonsUSDMedium,
    FO: exports.familyAddonsUSDMedium,
    GA: exports.familyAddonsUSDMedium,
    GD: exports.familyAddonsUSDMedium,
    GE: exports.familyAddonsUSDMedium,
    GG: exports.familyAddonsUSDMedium,
    GH: exports.familyAddonsUSDMedium,
    GI: exports.familyAddonsUSDMedium,
    GM: exports.familyAddonsUSDMedium,
    GP: exports.familyAddonsUSDMedium,
    GQ: exports.familyAddonsUSDMedium,
    GR: exports.familyAddonsUSDMedium,
    GT: exports.familyAddonsUSDMedium,
    GU: exports.familyAddonsUSDMedium,
    HK: exports.familyAddonsUSDMedium,
    HN: exports.familyAddonsUSDMedium,
    HR: exports.familyAddonsUSDMedium,
    HT: exports.familyAddonsUSDMedium,
    ID: exports.familyAddonsUSDMedium,
    IL: exports.familyAddonsUSDMedium,
    IN: exports.familyAddonsUSDMedium,
    IQ: exports.familyAddonsUSDMedium,
    IR: exports.familyAddonsUSDMedium,
    IS: exports.familyAddonsUSDMedium,
    JE: exports.familyAddonsUSDMedium,
    JM: exports.familyAddonsUSDMedium,
    JO: exports.familyAddonsUSDMedium,
    JP: exports.familyAddonsUSDMedium,
    KE: exports.familyAddonsUSDMedium,
    KG: exports.familyAddonsUSDMedium,
    KH: exports.familyAddonsUSDMedium,
    KN: exports.familyAddonsUSDMedium,
    KR: exports.familyAddonsUSDMedium,
    KY: exports.familyAddonsUSDMedium,
    LA: exports.familyAddonsUSDMedium,
    LB: exports.familyAddonsUSDMedium,
    LC: exports.familyAddonsUSDMedium,
    LI: exports.familyAddonsUSDMedium,
    LK: exports.familyAddonsUSDMedium,
    LS: exports.familyAddonsUSDMedium,
    LT: exports.familyAddonsUSDMedium,
    LV: exports.familyAddonsUSDMedium,
    LY: exports.familyAddonsUSDMedium,
    MA: exports.familyAddonsUSDMedium,
    MC: exports.familyAddonsUSDMedium,
    MD: exports.familyAddonsUSDMedium,
    ME: exports.familyAddonsUSDMedium,
    MG: exports.familyAddonsUSDMedium,
    MK: exports.familyAddonsUSDMedium,
    ML: exports.familyAddonsUSDMedium,
    MM: exports.familyAddonsUSDMedium,
    MN: exports.familyAddonsUSDMedium,
    MO: exports.familyAddonsUSDMedium,
    MQ: exports.familyAddonsUSDMedium,
    MR: exports.familyAddonsUSDMedium,
    MT: exports.familyAddonsUSDMedium,
    MU: exports.familyAddonsUSDMedium,
    MV: exports.familyAddonsUSDMedium,
    MW: exports.familyAddonsUSDMedium,
    MX: exports.familyAddonsUSDMedium,
    MY: exports.familyAddonsUSDMedium,
    MZ: exports.familyAddonsUSDMedium,
    NA: exports.familyAddonsUSDMedium,
    NC: exports.familyAddonsUSDMedium,
    NE: exports.familyAddonsUSDMedium,
    NF: exports.familyAddonsUSDMedium,
    NG: exports.familyAddonsUSDMedium,
    NI: exports.familyAddonsUSDMedium,
    NP: exports.familyAddonsUSDMedium,
    NZ: exports.familyAddonsUSDMedium,
    PA: exports.familyAddonsUSDMedium,
    PE: exports.familyAddonsUSDMedium,
    PF: exports.familyAddonsUSDMedium,
    PG: exports.familyAddonsUSDMedium,
    PH: exports.familyAddonsUSDMedium,
    PK: exports.familyAddonsUSDMedium,
    PR: exports.familyAddonsUSDMedium,
    PS: exports.familyAddonsUSDMedium,
    PY: exports.familyAddonsUSDMedium,
    RE: exports.familyAddonsUSDMedium,
    RS: exports.familyAddonsUSDMedium,
    RU: exports.familyAddonsUSDMedium,
    RW: exports.familyAddonsUSDMedium,
    SC: exports.familyAddonsUSDMedium,
    SD: exports.familyAddonsUSDMedium,
    SG: exports.familyAddonsUSDMedium,
    SI: exports.familyAddonsUSDMedium,
    SK: exports.familyAddonsUSDMedium,
    SL: exports.familyAddonsUSDMedium,
    SM: exports.familyAddonsUSDMedium,
    SN: exports.familyAddonsUSDMedium,
    SO: exports.familyAddonsUSDMedium,
    SS: exports.familyAddonsUSDMedium,
    SV: exports.familyAddonsUSDMedium,
    SY: exports.familyAddonsUSDMedium,
    SZ: exports.familyAddonsUSDMedium,
    TD: exports.familyAddonsUSDMedium,
    TG: exports.familyAddonsUSDMedium,
    TH: exports.familyAddonsUSDMedium,
    TJ: exports.familyAddonsUSDMedium,
    TL: exports.familyAddonsUSDMedium,
    TN: exports.familyAddonsUSDMedium,
    TR: exports.familyAddonsUSDMedium,
    TV: exports.familyAddonsUSDMedium,
    TW: exports.familyAddonsUSDMedium,
    TZ: exports.familyAddonsUSDMedium,
    UA: exports.familyAddonsUSDMedium,
    UG: exports.familyAddonsUSDMedium,
    UY: exports.familyAddonsUSDMedium,
    UZ: exports.familyAddonsUSDMedium,
    VC: exports.familyAddonsUSDMedium,
    VE: exports.familyAddonsUSDMedium,
    VG: exports.familyAddonsUSDMedium,
    VI: exports.familyAddonsUSDMedium,
    VN: exports.familyAddonsUSDMedium,
    VU: exports.familyAddonsUSDMedium,
    XK: exports.familyAddonsUSDMedium,
    YE: exports.familyAddonsUSDMedium,
    YT: exports.familyAddonsUSDMedium,
    ZA: exports.familyAddonsUSDMedium,
    ZM: exports.familyAddonsUSDMedium,
    ZW: exports.familyAddonsUSDMedium,
    AE: exports.familyAddonsUS,
    BH: exports.familyAddonsUS,
    BN: exports.familyAddonsUS,
    BW: exports.familyAddonsUS,
    BZ: exports.familyAddonsUS,
    EE: exports.familyAddonsUS,
    GY: exports.familyAddonsUS,
    KW: exports.familyAddonsUS,
    KZ: exports.familyAddonsUS,
    LU: exports.familyAddonsUS,
    OM: exports.familyAddonsUS,
    QA: exports.familyAddonsUS,
    SA: exports.familyAddonsUS,
    SR: exports.familyAddonsUS,
    TM: exports.familyAddonsUS,
    TT: exports.familyAddonsUS,
    AT: exports.familyAddonsEU,
    BE: exports.familyAddonsEU,
    DK: exports.familyAddonsEU,
    FI: exports.familyAddonsEU,
    FR: exports.familyAddonsEU,
    DE: exports.familyAddonsEU,
    IT: exports.familyAddonsEU,
    IE: exports.familyAddonsEU,
    NL: exports.familyAddonsEU,
    NO: exports.familyAddonsEU,
    PL: exports.familyAddonsEU,
    ES: exports.familyAddonsEU,
    SE: exports.familyAddonsEU,
    CH: exports.familyAddonsEU,
    CZ: exports.familyAddonsEU,
    HU: exports.familyAddonsEU,
    CY: exports.familyAddonsEU,
    PT: exports.familyAddonsEU,
    RO: exports.familyAddonsEU,
    BG: exports.familyAddonsEU,
};
exports.familyAddons = [
    exports.familyAddonsGB,
    exports.familyAddonsUS,
    exports.familyAddonsAU,
    exports.familyAddonsCA,
    exports.familyAddonsEU,
    exports.familyAddonsUSDMedium,
].reduce((allFamilyAddons, addonSetForCurrency) => {
    Object.values(addonSetForCurrency).forEach(addon => {
        allFamilyAddons[addon.id] = addon;
    });
    return allFamilyAddons;
}, {});
const tier1 = {
    title: 'Starter plan',
    description: 'Get started in your climate action journey.',
    status: user_1.ClimateStatus.FRIENDLY,
};
const tier2 = {
    title: 'Essential plan',
    description: 'Make an impact with our most popular plan.',
    status: user_1.ClimateStatus.POSITIVE,
};
const tier3 = {
    title: 'Ultimate plan',
    description: 'Double your impact and put the climate at the top of your agenda.',
    status: user_1.ClimateStatus.POSITIVE,
};
exports.businessAddonsUS = {
    tier1: Object.assign({ id: 'tier-1-v3-usd', price: 16.25, stats: impact_stats_1.b2bImpactStats.high.tier1 }, tier1),
    tier2: Object.assign({ id: 'tier-2-v3-usd', price: 32.5, stats: impact_stats_1.b2bImpactStats.high.tier2 }, tier2),
    tier3: Object.assign({ id: 'tier-3-v3-usd', price: 64.95, stats: impact_stats_1.b2bImpactStats.high.tier3 }, tier3),
};
exports.businessAddonsUSDMedium = {
    tier1: Object.assign({ id: 'tier-1-v3-usd-medium', price: 7.65, stats: impact_stats_1.b2bImpactStats.medium.tier1 }, tier1),
    tier2: Object.assign({ id: 'tier-2-v3-usd-medium', price: 15.3, stats: impact_stats_1.b2bImpactStats.medium.tier2 }, tier2),
    tier3: Object.assign({ id: 'tier-3-v3-usd-medium', price: 30.6, stats: impact_stats_1.b2bImpactStats.medium.tier3 }, tier3),
};
exports.businessAddonsAU = {
    tier1: Object.assign({ id: 'tier-1-v3-aud', price: 21.8, stats: impact_stats_1.b2bImpactStats.high.tier1 }, tier1),
    tier2: Object.assign({ id: 'tier-2-v3-aud', price: 43.6, stats: impact_stats_1.b2bImpactStats.high.tier2 }, tier2),
    tier3: Object.assign({ id: 'tier-3-v3-aud', price: 87.2, stats: impact_stats_1.b2bImpactStats.high.tier3 }, tier3),
};
exports.businessAddonsCA = {
    tier1: Object.assign({ id: 'tier-1-v3-cad', price: 20.3, stats: impact_stats_1.b2bImpactStats.high.tier1 }, tier1),
    tier2: Object.assign({ id: 'tier-2-v3-cad', price: 40.6, stats: impact_stats_1.b2bImpactStats.high.tier2 }, tier2),
    tier3: Object.assign({ id: 'tier-3-v3-cad', price: 81.2, stats: impact_stats_1.b2bImpactStats.high.tier3 }, tier3),
};
exports.businessAddonsGB = {
    tier1: Object.assign({ id: 'tier-1-v3-gbp', price: 5.35, stats: impact_stats_1.b2bImpactStats.medium.tier1 }, tier1),
    tier2: Object.assign({ id: 'tier-2-v3-gbp', price: 10.7, stats: impact_stats_1.b2bImpactStats.medium.tier2 }, tier2),
    tier3: Object.assign({ id: 'tier-3-v3-gbp', price: 21.4, stats: impact_stats_1.b2bImpactStats.medium.tier3 }, tier3),
};
exports.businessAddonsEU = {
    tier1: Object.assign({ id: 'tier-1-v3-eur', price: 6.45, stats: impact_stats_1.b2bImpactStats.medium.tier1 }, tier1),
    tier2: Object.assign({ id: 'tier-2-v3-eur', price: 12.9, stats: impact_stats_1.b2bImpactStats.medium.tier2 }, tier2),
    tier3: Object.assign({ id: 'tier-3-v3-eur', price: 25.8, stats: impact_stats_1.b2bImpactStats.medium.tier3 }, tier3),
};
exports.businessAddons = [
    exports.businessAddonsGB,
    exports.businessAddonsUS,
    exports.businessAddonsAU,
    exports.businessAddonsCA,
    exports.businessAddonsEU,
    exports.businessAddonsUSDMedium,
].reduce((allBusinessAddons, addonSetForCurrency) => {
    Object.values(addonSetForCurrency).forEach(addon => {
        allBusinessAddons[addon.id] = addon;
    });
    return allBusinessAddons;
}, {});
exports.businessLocationAddonMapper = {
    GB: exports.businessAddonsGB,
    US: exports.businessAddonsUS,
    AU: exports.businessAddonsAU,
    CA: exports.businessAddonsCA,
    EU: exports.businessAddonsEU,
    AD: exports.businessAddonsUSDMedium,
    AF: exports.businessAddonsUSDMedium,
    AG: exports.businessAddonsUSDMedium,
    AL: exports.businessAddonsUSDMedium,
    AM: exports.businessAddonsUSDMedium,
    AO: exports.businessAddonsUSDMedium,
    AQ: exports.businessAddonsUSDMedium,
    AR: exports.businessAddonsUSDMedium,
    AW: exports.businessAddonsUSDMedium,
    AZ: exports.businessAddonsUSDMedium,
    BA: exports.businessAddonsUSDMedium,
    BB: exports.businessAddonsUSDMedium,
    BD: exports.businessAddonsUSDMedium,
    BF: exports.businessAddonsUSDMedium,
    BI: exports.businessAddonsUSDMedium,
    BJ: exports.businessAddonsUSDMedium,
    BM: exports.businessAddonsUSDMedium,
    BO: exports.businessAddonsUSDMedium,
    BQ: exports.businessAddonsUSDMedium,
    BR: exports.businessAddonsUSDMedium,
    BS: exports.businessAddonsUSDMedium,
    BT: exports.businessAddonsUSDMedium,
    BY: exports.businessAddonsUSDMedium,
    CD: exports.businessAddonsUSDMedium,
    CI: exports.businessAddonsUSDMedium,
    CL: exports.businessAddonsUSDMedium,
    CM: exports.businessAddonsUSDMedium,
    CN: exports.businessAddonsUSDMedium,
    CO: exports.businessAddonsUSDMedium,
    CR: exports.businessAddonsUSDMedium,
    CU: exports.businessAddonsUSDMedium,
    CV: exports.businessAddonsUSDMedium,
    CW: exports.businessAddonsUSDMedium,
    DO: exports.businessAddonsUSDMedium,
    DZ: exports.businessAddonsUSDMedium,
    EC: exports.businessAddonsUSDMedium,
    EG: exports.businessAddonsUSDMedium,
    EH: exports.businessAddonsUSDMedium,
    ET: exports.businessAddonsUSDMedium,
    FJ: exports.businessAddonsUSDMedium,
    FK: exports.businessAddonsUSDMedium,
    FM: exports.businessAddonsUSDMedium,
    FO: exports.businessAddonsUSDMedium,
    GA: exports.businessAddonsUSDMedium,
    GD: exports.businessAddonsUSDMedium,
    GE: exports.businessAddonsUSDMedium,
    GG: exports.businessAddonsUSDMedium,
    GH: exports.businessAddonsUSDMedium,
    GI: exports.businessAddonsUSDMedium,
    GM: exports.businessAddonsUSDMedium,
    GP: exports.businessAddonsUSDMedium,
    GQ: exports.businessAddonsUSDMedium,
    GR: exports.businessAddonsUSDMedium,
    GT: exports.businessAddonsUSDMedium,
    GU: exports.businessAddonsUSDMedium,
    HK: exports.businessAddonsUSDMedium,
    HN: exports.businessAddonsUSDMedium,
    HR: exports.businessAddonsUSDMedium,
    HT: exports.businessAddonsUSDMedium,
    ID: exports.businessAddonsUSDMedium,
    IL: exports.businessAddonsUSDMedium,
    IN: exports.businessAddonsUSDMedium,
    IQ: exports.businessAddonsUSDMedium,
    IR: exports.businessAddonsUSDMedium,
    IS: exports.businessAddonsUSDMedium,
    JE: exports.businessAddonsUSDMedium,
    JM: exports.businessAddonsUSDMedium,
    JO: exports.businessAddonsUSDMedium,
    JP: exports.businessAddonsUSDMedium,
    KE: exports.businessAddonsUSDMedium,
    KG: exports.businessAddonsUSDMedium,
    KH: exports.businessAddonsUSDMedium,
    KN: exports.businessAddonsUSDMedium,
    KR: exports.businessAddonsUSDMedium,
    KY: exports.businessAddonsUSDMedium,
    LA: exports.businessAddonsUSDMedium,
    LB: exports.businessAddonsUSDMedium,
    LC: exports.businessAddonsUSDMedium,
    LI: exports.businessAddonsUSDMedium,
    LK: exports.businessAddonsUSDMedium,
    LS: exports.businessAddonsUSDMedium,
    LT: exports.businessAddonsUSDMedium,
    LV: exports.businessAddonsUSDMedium,
    LY: exports.businessAddonsUSDMedium,
    MA: exports.businessAddonsUSDMedium,
    MC: exports.businessAddonsUSDMedium,
    MD: exports.businessAddonsUSDMedium,
    ME: exports.businessAddonsUSDMedium,
    MG: exports.businessAddonsUSDMedium,
    MK: exports.businessAddonsUSDMedium,
    ML: exports.businessAddonsUSDMedium,
    MM: exports.businessAddonsUSDMedium,
    MN: exports.businessAddonsUSDMedium,
    MO: exports.businessAddonsUSDMedium,
    MQ: exports.businessAddonsUSDMedium,
    MR: exports.businessAddonsUSDMedium,
    MT: exports.businessAddonsUSDMedium,
    MU: exports.businessAddonsUSDMedium,
    MV: exports.businessAddonsUSDMedium,
    MW: exports.businessAddonsUSDMedium,
    MX: exports.businessAddonsUSDMedium,
    MY: exports.businessAddonsUSDMedium,
    MZ: exports.businessAddonsUSDMedium,
    NA: exports.businessAddonsUSDMedium,
    NC: exports.businessAddonsUSDMedium,
    NE: exports.businessAddonsUSDMedium,
    NF: exports.businessAddonsUSDMedium,
    NG: exports.businessAddonsUSDMedium,
    NI: exports.businessAddonsUSDMedium,
    NP: exports.businessAddonsUSDMedium,
    NZ: exports.businessAddonsUSDMedium,
    PA: exports.businessAddonsUSDMedium,
    PE: exports.businessAddonsUSDMedium,
    PF: exports.businessAddonsUSDMedium,
    PG: exports.businessAddonsUSDMedium,
    PH: exports.businessAddonsUSDMedium,
    PK: exports.businessAddonsUSDMedium,
    PR: exports.businessAddonsUSDMedium,
    PS: exports.businessAddonsUSDMedium,
    PY: exports.businessAddonsUSDMedium,
    RE: exports.businessAddonsUSDMedium,
    RS: exports.businessAddonsUSDMedium,
    RU: exports.businessAddonsUSDMedium,
    RW: exports.businessAddonsUSDMedium,
    SC: exports.businessAddonsUSDMedium,
    SD: exports.businessAddonsUSDMedium,
    SG: exports.businessAddonsUSDMedium,
    SI: exports.businessAddonsUSDMedium,
    SK: exports.businessAddonsUSDMedium,
    SL: exports.businessAddonsUSDMedium,
    SM: exports.businessAddonsUSDMedium,
    SN: exports.businessAddonsUSDMedium,
    SO: exports.businessAddonsUSDMedium,
    SS: exports.businessAddonsUSDMedium,
    SV: exports.businessAddonsUSDMedium,
    SY: exports.businessAddonsUSDMedium,
    SZ: exports.businessAddonsUSDMedium,
    TD: exports.businessAddonsUSDMedium,
    TG: exports.businessAddonsUSDMedium,
    TH: exports.businessAddonsUSDMedium,
    TJ: exports.businessAddonsUSDMedium,
    TL: exports.businessAddonsUSDMedium,
    TN: exports.businessAddonsUSDMedium,
    TR: exports.businessAddonsUSDMedium,
    TV: exports.businessAddonsUSDMedium,
    TW: exports.businessAddonsUSDMedium,
    TZ: exports.businessAddonsUSDMedium,
    UA: exports.businessAddonsUSDMedium,
    UG: exports.businessAddonsUSDMedium,
    UY: exports.businessAddonsUSDMedium,
    UZ: exports.businessAddonsUSDMedium,
    VC: exports.businessAddonsUSDMedium,
    VE: exports.businessAddonsUSDMedium,
    VG: exports.businessAddonsUSDMedium,
    VI: exports.businessAddonsUSDMedium,
    VN: exports.businessAddonsUSDMedium,
    VU: exports.businessAddonsUSDMedium,
    XK: exports.businessAddonsUSDMedium,
    YE: exports.businessAddonsUSDMedium,
    YT: exports.businessAddonsUSDMedium,
    ZA: exports.businessAddonsUSDMedium,
    ZM: exports.businessAddonsUSDMedium,
    ZW: exports.businessAddonsUSDMedium,
    AE: exports.businessAddonsUS,
    BH: exports.businessAddonsUS,
    BN: exports.businessAddonsUS,
    BW: exports.businessAddonsUS,
    BZ: exports.businessAddonsUS,
    EE: exports.businessAddonsUS,
    GY: exports.businessAddonsUS,
    KW: exports.businessAddonsUS,
    KZ: exports.businessAddonsUS,
    LU: exports.businessAddonsUS,
    OM: exports.businessAddonsUS,
    QA: exports.businessAddonsUS,
    SA: exports.businessAddonsUS,
    SR: exports.businessAddonsUS,
    TM: exports.businessAddonsUS,
    TT: exports.businessAddonsUS,
    AT: exports.businessAddonsEU,
    BE: exports.businessAddonsEU,
    DK: exports.businessAddonsEU,
    FI: exports.businessAddonsEU,
    FR: exports.businessAddonsEU,
    DE: exports.businessAddonsEU,
    IT: exports.businessAddonsEU,
    IE: exports.businessAddonsEU,
    NL: exports.businessAddonsEU,
    NO: exports.businessAddonsEU,
    PL: exports.businessAddonsEU,
    ES: exports.businessAddonsEU,
    SE: exports.businessAddonsEU,
    CH: exports.businessAddonsEU,
    CZ: exports.businessAddonsEU,
    HU: exports.businessAddonsEU,
    CY: exports.businessAddonsEU,
    PT: exports.businessAddonsEU,
    BG: exports.businessAddonsEU,
    RO: exports.businessAddonsEU,
};
// Helper for building arrays of addons
const addonBuilder = (name) => [
    `${name}-v3-gbp`,
    `${name}-v3-aud`,
    `${name}-v3-cad`,
    `${name}-v3-eur`,
    `${name}-v3-usd`,
    `${name}-v3-usd-medium`,
];
exports.tier1AddonIds = addonBuilder('tier-1');
exports.tier2AddonIds = addonBuilder('tier-2');
exports.tier3AddonIds = addonBuilder('tier-3');
exports.adultAddonIds = addonBuilder('adult');
exports.childAddonIds = addonBuilder('child');
exports.petAddonIds = addonBuilder('pet');
/**
 * Helper method which returns the identifiers of those addons which are valid (and required) for the currently offered plans
 * Note - this data should be moved to a database along with the rest of the plan data
 * @param {string} planId
 * @returns {string[]}
 */
const getRequiredAddonsForPlanId = (planId) => {
    switch (planId) {
        case plans_1.businessPlanIdGB:
            return ['tier-1-v3-gbp', 'tier-2-v3-gbp', 'tier-3-v3-gbp'];
        case plans_1.businessPlanIdUS:
            return ['tier-1-v3-usd', 'tier-2-v3-usd', 'tier-3-v3-usd'];
        case plans_1.businessPlanIdUSDMedium:
            return ['tier-1-v3-usd-medium', 'tier-2-v3-usd-medium', 'tier-3-v3-usd-medium'];
        case plans_1.businessPlanIdEU:
            return ['tier-1-v3-eur', 'tier-2-v3-eur', 'tier-3-v3-eur'];
        case plans_1.businessPlanIdAU:
            return ['tier-1-v3-aud', 'tier-2-v3-aud', 'tier-3-v3-aud'];
        case plans_1.businessPlanIdCA:
            return ['tier-1-v3-cad', 'tier-2-v3-cad', 'tier-3-v3-cad'];
        case plans_1.familyPlanIdGB:
            return ['adult-v3-gbp', 'child-v3-gbp', 'pet-v3-gbp'];
        case plans_1.familyPlanIdUS:
            return ['adult-v3-usd', 'child-v3-usd', 'pet-v3-usd'];
        case plans_1.familyPlanIdUSMedium:
            return ['adult-v3-usd-medium', 'child-v3-usd-medium', 'pet-v3-usd-medium'];
        case plans_1.familyPlanIdEU:
            return ['adult-v3-eur', 'child-v3-eur', 'pet-v3-eur'];
        case plans_1.familyPlanIdAU:
            return ['adult-v3-aud', 'child-v3-aud', 'pet-v3-aud'];
        case plans_1.familyPlanIdCA:
            return ['adult-v3-cad', 'child-v3-cad', 'pet-v3-cad'];
        default:
            return [];
    }
};
exports.getRequiredAddonsForPlanId = getRequiredAddonsForPlanId;
/**
 */
const getOptionalAddonsForPlanId = (planId) => {
    switch (planId) {
        case plans_1.personalPlanIdGB:
        case plans_1.boosterPlanIdGB:
        case plans_1.megaPlanIdGB:
            return [tree_projects_1.UKReforestationProject.id];
        case plans_1.personalPlanIdUS:
        case plans_1.boosterPlanIdUS:
        case plans_1.megaPlanIdUS:
            return [tree_projects_1.USReforestationProject.id];
        case plans_1.personalPlanIdAU:
            return [tree_projects_1.AUReforestationProject.id];
        case plans_1.businessPlanIdGB:
            return [tree_projects_1.UKReforestationProject.id];
        case plans_1.businessPlanIdUS:
            return [tree_projects_1.USReforestationProject.id];
        case plans_1.businessPlanIdAU:
            return [tree_projects_1.AUReforestationProject.id];
        case plans_1.familyPlanIdGB:
            return [tree_projects_1.UKReforestationProject.id];
        case plans_1.familyPlanIdUS:
            return [tree_projects_1.USReforestationProject.id];
        case plans_1.familyPlanIdAU:
            return [tree_projects_1.AUReforestationProject.id];
        default:
            return [];
    }
};
exports.getOptionalAddonsForPlanId = getOptionalAddonsForPlanId;
/**
 * Is there at least one required addon supplied for the planId
 */
const hasMinimumRequiredAddonsForPlan = (planId, addonIds) => {
    const isBusinessPlan = (0, plans_1.isCurrentBusinessPlan)(planId);
    const isFamilyPlan = (0, plans_1.isCurrentFamilyPlan)(planId);
    //  Is the planId for one which has required addons
    if (isBusinessPlan || isFamilyPlan) {
        const requiredPlanAddons = (0, exports.getRequiredAddonsForPlanId)(planId);
        const suppliedAddonsSet = new Set(addonIds);
        //  Ensure first of all that if the plan requires add-ons that at least one of those is supplied otherwise it is an error
        const requiredIntersectionAddonsSet = new Set([...requiredPlanAddons].filter(a => suppliedAddonsSet.has(a)));
        if (isBusinessPlan) {
            return requiredIntersectionAddonsSet.size > 0;
        }
        else {
            //  You must have 2 or more family addons for it to be considered a valid subscription)
            //  So (1 Adult & 1 Child) or (1 Adult & 1 Pet) or (1 Child & 1 Pet) or (1 Adult & 1 Child & 1 Pet)
            return requiredIntersectionAddonsSet.size > 1;
        }
    }
    return true;
};
exports.hasMinimumRequiredAddonsForPlan = hasMinimumRequiredAddonsForPlan;
/**
 * Helper method to determine if the specified addons are valid for the given planId
 * @param {string} planId - The identifier of the subscription plan
 * @param {string[]} addonIds - The array of addon identifiers to test
 * @param {Location} location - The location in which the check for addons against the plan is being made
 */
const areAllValidAddonsForPlan = (planId, addonIds, location) => {
    const requiredPlanAddons = (0, exports.getRequiredAddonsForPlanId)(planId);
    const requiredPlanAddonsSet = new Set(requiredPlanAddons);
    const optionalPlanAddons = (0, exports.getOptionalAddonsForPlanId)(planId);
    const suppliedAddonsSet = new Set(addonIds);
    const countryCode = (0, country_transform_1.transformLocationIntoValidPlanCountryCode)(location);
    //  We need to remove the USReforestation project Id from Saudi Arabia and United Arab Emirates
    if (countryCode === 'SA' || countryCode === 'AE') {
        const USReforestationIdx = optionalPlanAddons.indexOf(tree_projects_1.USReforestationProject.id);
        optionalPlanAddons.splice(USReforestationIdx, 1);
    }
    const optionalPlanAddonsSet = new Set(optionalPlanAddons);
    if ((0, exports.hasMinimumRequiredAddonsForPlan)(planId, addonIds)) {
        // Perform a Set Union to get all valid plan addon details
        const allPlanAddonIds = new Set([...requiredPlanAddonsSet, ...optionalPlanAddonsSet]);
        //  Perform a Set Intersection to determine if all of the supplied addonIds are in the list of
        //  only those addons which are valid for the Plan
        const intersectionAddons = new Set([...allPlanAddonIds].filter(a => suppliedAddonsSet.has(a)));
        //  If the number of addons supplied is the same as the number of addons which are allowed for the plan
        //  then we have a valid set of supplied addons (otherwise there is an error)
        return intersectionAddons.size === suppliedAddonsSet.size;
    }
    else {
        return false;
    }
};
exports.areAllValidAddonsForPlan = areAllValidAddonsForPlan;
const isCurrentAddon = (addonId) => {
    return addonId.includes('v3');
};
exports.isCurrentAddon = isCurrentAddon;
const isUSMediumAddon = (addonId) => {
    return addonId.includes('medium');
};
exports.isUSMediumAddon = isUSMediumAddon;
const isBusinessAddon = (addonId) => {
    return addonId.includes('tier');
};
exports.isBusinessAddon = isBusinessAddon;
const isTierOneAddon = (addonId) => {
    return addonId.includes('tier-1');
};
exports.isTierOneAddon = isTierOneAddon;
const isTierTwoAddon = (addonId) => {
    return addonId.includes('tier-2');
};
exports.isTierTwoAddon = isTierTwoAddon;
const isTierThreeAddon = (addonId) => {
    return addonId.includes('tier-3');
};
exports.isTierThreeAddon = isTierThreeAddon;
const isFamilyAddon = (addonId) => {
    return (0, exports.isAdultAddon)(addonId) || (0, exports.isChildAddon)(addonId) || (0, exports.isPetAddon)(addonId);
};
exports.isFamilyAddon = isFamilyAddon;
const isAdultAddon = (addonId) => {
    return addonId.includes('adult');
};
exports.isAdultAddon = isAdultAddon;
const isChildAddon = (addonId) => {
    return addonId.includes('child');
};
exports.isChildAddon = isChildAddon;
const isPetAddon = (addonId) => {
    return addonId.includes('pet');
};
exports.isPetAddon = isPetAddon;
//# sourceMappingURL=data:application/json;base64,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